import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { CookieHelper } from "../../Lib/Helper/CookieHelper";

@ModuleName("Banner")
export class Banner implements AxInit {
    constructor(private _cookieHelper = new CookieHelper()){}

    AxInit(init: IBannerInitData): void {
        const $alertBanner = $('.ax-alert-banner-holder');
        const $infoBanner = $('.ax-info-banner-holder');

        if ($alertBanner.length > 0) {
            const bannerId = $alertBanner.attr('data-id');
            this._cookieHelper.setCookie('ax_abv_' + bannerId, true, 7);

            if (init.alertConfig.alertBannerAllowClosing) {
                $('.ax-alert-banner-holder .closeButtonBanner').click(x => {
                    this._cookieHelper.setCookie('ax_abc_' + bannerId, true, 7);

                    $alertBanner.remove();
                    $('body').removeClass('ax-head-banner_a');
                });
            }

            $('body').addClass('ax-head-banner_a');
        }

        if ($infoBanner.length > 0) {
            let bannerId = $infoBanner.attr('data-id');
            this._cookieHelper.setCookie('ax_ibv_' + bannerId, true, 7);

            if (init.infoConfig.infoBannerAllowClosing) {
                $('.ax-info-banner-holder .ax-info-banner-close-btn').click(x => {
                    this._cookieHelper.setCookie('ax_ibc_' + bannerId, true, 7);

                    $infoBanner.remove();
                });
            }
        }
    }
}



interface IBannerInitData {
    alertConfig: IAlertConfig;
    infoConfig: IInfoConfig;
}

interface IAlertConfig {
    alertBannerAllowClosing: boolean;
}

interface IInfoConfig {
    infoBannerAllowClosing: boolean;
}